import React, { Component } from "react";
import {  Fab, Tooltip,withStyles } from "@material-ui/core";

const TooltipNew = withStyles((theme) => ({
    tooltip: {
        fontSize: 14,
    },
}))(Tooltip);

class FilterLogoCommon extends Component {
    render() {
        var str, matches, acronym = ""
        if (JSON.parse(localStorage.getItem('user_data_session')) && JSON.parse(localStorage.getItem('user_data_session')).name) {
            str = JSON.parse(localStorage.getItem('user_data_session')).name
            matches = str.match(/\b(\w)/g); // ['J','S','O','N']
            acronym = matches.join(''); // JSON
        }
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 8px 8px' }}>
                <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#37474f' }}>
                    {this.props.headerKey}
                </div>
                <div>
                    <TooltipNew title={str}>
                        <Fab size="small" style={{ width: '30px', height: '30px', minHeight: '30px', background: 'rgba(0,0,0,0.05)', boxShadow: 'none' }}>
                            <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#546e7a', margin: 0 }}>
                                {acronym}
                            </span>
                        </Fab>
                    </TooltipNew>
                </div>
            </div>
        );
    }
}

export default FilterLogoCommon